import React from "react";
import Styled, { CustomModal, LineBreak } from "./styles";

const numberWithCommas = n =>
  n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

const ModalExhibit4 = ({ machines, goBack }) => (
  <CustomModal goBack={goBack}>
    <b>EXHIBIT 4 - Production Lines</b>
    <LineBreak />
    <Styled.ModalTable>
      <tbody>
        <tr>
          <th>Production Line</th>
          <th>Costs</th>
          <th>Units Per Hour</th>
          <th>Estimated Useful Life</th>
          <th>Annual Capacity (in hours)</th>
          <th>Setup Time (in months)</th>
          <th>Ideal Utilization Rate</th>
        </tr>
        {machines.map(machine => (
          <tr key={machine.id}>
            <td>{machine.id}</td>
            <td>${numberWithCommas(machine.costs)}</td>
            <td>{machine.units_per_hour}</td>
            <td>{machine.lifetime_years} years</td>
            <td>{numberWithCommas(machine.annual_hours)}</td>
            <td>{machine.setup_time}</td>
            <td>75%</td>
          </tr>
        ))}
      </tbody>
    </Styled.ModalTable>
  </CustomModal>
);

export default ModalExhibit4;



// WEBPACK FOOTER //
// ./src/components/bcase/ModalExhibit4.js